<reporter-modal [displayCloseBtn]="true"
  [noFooter]="true"
  [show]="incidentId !== undefined"
  modalTitle="Printable Documents"
  modalClasses="modal-lg"
  (onClose)="onClose.emit()">

  <div role="modal-body"
    class="printable-documents">
    <reporter-notifications #notifications
    [clearOnNew]="true"></reporter-notifications>
    <div class="content">
      @if (documents?.length > 0) {
        <div
          class="documents-table">
          <div class="documents-table-header"></div>
          <div class="documents-table-header">File Description</div>
          @for (document of documents; track document) {
            <div class="documents-table-row"
              (click)="printDocument(document.formTemplateId)">
              <div class="documents-table-cell">
                <reporter-icon icon="Print"></reporter-icon>
              </div>
              <div class="documents-table-cell">
                <span>{{ document.name }}</span>
              </div>
            </div>
          }
        </div>
      }
      @if (documents?.length === 0) {
        <div>
          There are no printable reports available for this Incident!
        </div>
      }
      @if (documents === undefined) {
        <div>
          Loading documents...
        </div>
      }
    </div>
  </div>
</reporter-modal>

